import * as actions from './actions'
import mutations from './mutations'

const SettlementStore = {
  namespaced: true,
  state: {
    settlements: []
  },
  actions,
  mutations
}

export default SettlementStore
